
<div class="grid flex-row flex-wrap gap-3 align-content-end justify-content-center">
		<h1 class="title">Brussels Airport TaxiFlow</h1>
<!--
 		<code>
		Device: {{this.deviceInfo.device}}
		<br>
		Info: {{deviceInfo | json}}
		</code>
-->
</div>
